module.exports = __webpack_public_path__ + "img/icon_customer_support.fea19ed9.svg";